import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {DashboardHomePage} from "../dashboard-home/dashboard-home";
import {InAppBrowser, InAppBrowserOptions} from "@ionic-native/in-app-browser";
import {SocialSharing} from "@ionic-native/social-sharing";


/**
 * Generated class for the SyncGoogleContactPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-sync-google-contact',
  templateUrl: 'sync-google-contact.html',
})
export class SyncGoogleContactPage {

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public InAppBrowser: InAppBrowser,public socialSharing:SocialSharing) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SyncGoogleContactPage');
  }

  dismiss()
  {
    // this.viewCtrl.dismiss();
    this.navCtrl.setRoot(DashboardHomePage);
  }


  syncContact()
  {
    let url='https://accounts.google.com/o/oauth2/auth?client_id=147499321982-2ucstu8avt5ddrgbb0i0pig3ggp1ghsq.apps.googleusercontent.com&redirect_uri=http://wwgsadmin.awtech.top/GoogleContact/google&scope=https://www.google.com/m8/feeds/&response_type=code';

   //this.socialSharing.shareVia('com.android.chrome',null,null,null,url);
    this.openWithSystemBrowser(url);

  }


  openWithSystemBrowser(url: string) {
    console.log('in system browser');

    let target = "_system";
    this.InAppBrowser.create(url, target, {
      location: 'yes',//Or 'no'
      hidden: 'no', //Or  'yes'
      clearcache: 'yes',
      hideurlbar: 'yes',
      clearsessioncache: 'yes',
      zoom: 'yes',//Android only ,shows browser zoom controls
      hardwareback: 'yes',
      mediaPlaybackRequiresUserAction: 'no',
      shouldPauseOnSuspend: 'no', //Android only
      closebuttoncaption: 'Close', //iOS only
      disallowoverscroll: 'no', //iOS only
      toolbar: 'yes', //iOS only
      enableViewportScale: 'no', //iOS only
      allowInlineMediaPlayback: 'no',//iOS only
      presentationstyle: 'pagesheet',//iOS only
      fullscreen: 'yes',//Windows only
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/sync-google-contact/sync-google-contact.ts